<h1 mat-dialog-title>
    <div class="dialog-header">
      <h2 class="dialog-title">Change Password</h2>
      <div><i class="fas fa-times" (click)="closeDialog()"></i></div>
    </div>
  </h1>
  <div mat-dialog-content>
    <form [formGroup]="changePasswordForm">
        <div class="form-group">
          <label for="oldPassword"
            >Old Password <span class="text-danger">*</span></label
          >
          <div style="display: grid; grid-template-columns: 5fr -0.1fr">
            <input
              [type]="showOldPassword ? 'text' : 'password'"
              placeholder="Enter new password"
              formControlName="oldPassword"
              class="form-control"
              [maxlength]="20"
              [minlength]="4"
              [ngClass]="{
                'is-invalid': f.oldPassword.invalid && f.oldPassword.touched,
                'is-valid':
                  f.oldPassword.valid &&
                  (f.oldPassword.dirty || f.oldPassword.touched)
              }"
            />

            <div style="margin: -28px 0px 0px 395px; z-index: 99999">
              <div *ngIf="showOldPassword; else elseOldblock">
                <i class="fa fa-eye" (click)="showHideOldPassword()" *ngIf="showOldPassword"></i>
              </div>
              <ng-template #elseOldblock
                ><i class="fa fa-eye-slash" (click)="showHideOldPassword()"></i
              ></ng-template>
            </div>

            <div></div>
            <div *ngIf="f.oldPassword.errors" class="invalid-feedback">
                <div *ngIf="f.oldPassword.errors.required">Old Password is required</div>
            </div>
          </div>
        </div>

        <div class="form-group">
            <label for="newPassword"
              >New Password <span class="text-danger">*</span></label
            >
            <div style="display: grid; grid-template-columns: 5fr -0.1fr">
              <input
                [type]="showNewPassword ? 'text' : 'password'"
                placeholder="Enter new password"
                formControlName="newPassword"
                class="form-control"
                [maxlength]="20"
                [minlength]="4"
                [ngClass]="{
                    'is-invalid': f.newPassword.invalid && f.newPassword.touched,
                    'is-valid':
                      f.newPassword.valid &&
                      (f.newPassword.dirty || f.newPassword.touched)
                  }"
              />
              <div style="margin: -28px 0px 0px 395px; z-index: 99999">
                <div *ngIf="showNewPassword; else elseNewblock">
                  <i class="fa fa-eye" (click)="showHideNewPassword()" *ngIf="showNewPassword"></i>
                </div>
                <ng-template #elseNewblock
                  ><i class="fa fa-eye-slash" (click)="showHideNewPassword()"></i
                ></ng-template>
              </div>
              <div></div>
              <div *ngIf="f.newPassword.errors" class="invalid-feedback">
                <div *ngIf="f.newPassword.errors.required">New Password is required</div>
              </div>
            </div>
          </div>

        <div class="form-group">
          <label for="confirmPassword"
            >Confirm Password &nbsp;<span class="text-danger">*</span></label
          >
  
          <input
            type="password"
            formControlName="confirmPassword"
            placeholder="Enter again"
            class="form-control"
            [maxlength]="20"
            [minlength]="4"
            [ngClass]="{
                'is-invalid': f.confirmPassword.invalid && f.confirmPassword.touched,
                'is-valid':
                  f.confirmPassword.valid &&
                  (f.confirmPassword.dirty || f.confirmPassword.touched)
              }"
          />
  
          <div *ngIf="f.confirmPassword.errors" class="invalid-feedback">
            <div *ngIf="f.confirmPassword.errors.required">Password is required</div>
        </div>
        </div>
  
    <div class="addEditBtn" >
      <button type="submit" class="btn btn-success" (click)="onSubmit()">Save</button>
    </div>
      </form>
  </div>